import React, { useContext } from 'react';
import cx from 'classnames';
import { shopApi } from 'api';

import { StoreContext } from 'store';
import { Icon } from 'components/Icons';
import { Button } from 'components/Button';
import { ButtonSize } from 'components/Button/Button';

import { getItemPrice } from './../helpers/items';

import './Item.scss';
import { Text } from 'components/Text';

interface PaymentButtonProps {
  item: shopApi.Item;
  onPaymentClick: (event: React.MouseEvent) => void;
  size?: ButtonSize;
  className?: string;
  isColumn?: boolean;
}

export const PaymentButton: React.FC<PaymentButtonProps> = ({
  item,
  onPaymentClick,
  size = 'm',
  isColumn = true,
  className,
}) => {
  const { translation: t } = useContext(StoreContext);

  const renderPrice = () => {
    const isDiscounted = item.price.amount !== item.price.amount_without_discount;
    const discountPercent = Math.round(
      Number(item.promotions?.[0]?.discount?.percent) ||
        (1 - Number(item.price.amount) / Number(item.price.amount_without_discount)) *
          100,
    );
    return (
      <div
        className={cx('payment-button__prices-wrapper', {
          'payment-button__prices-wrapper-column': isColumn,
        })}
      >
        <div className="payment-button__prices-text">
          {isDiscounted && (
            <Text.ParagraphL
              className="payment-button__price_without_discount"
              hasMobileSize={false}
            >
              {getItemPrice(item, item.price.amount_without_discount, t)}
            </Text.ParagraphL>
          )}
          <Text.CapsL
            className="payment-button__price_with_discount"
            hasMobileSize={false}
          >
            {getItemPrice(item, item.price.amount, t)}
          </Text.CapsL>
        </div>
        {isDiscounted && <DiscountLabel percent={discountPercent || 0} />}
      </div>
    );
  };

  return (
    <div className={cx('payment-button__wrapper', className)}>
      {renderPrice()}
      <Button
        withTriangle
        Icon={Icon.MarketCart}
        onClick={onPaymentClick}
        size={size}
      >
        {t.market.action.buy}
      </Button>
    </div>
  );
};

interface DiscountLabelProps {
  percent: number;
}

const DiscountLabel: React.FC<DiscountLabelProps> = ({ percent }) => {
  return (
    <div className="payment-button__discount-label">
      <div className="payment-button__discount-label--triangle" />
      <Text.CapsS className="payment-button__discount-label--text">
        -{percent}%
      </Text.CapsS>
    </div>
  );
};
